module.exports = __webpack_public_path__ + "img/bg_video_snapshot.baf53f37.png";